import { RoleIdResolver } from './role-id.resolver';
import { RoleResolver } from './role-resolver';
import { UsuarioPorIdResolver } from './usuario-por-id-resolver';

export const IdentidadeResolver = [
  UsuarioPorIdResolver,
  RoleResolver,
  RoleIdResolver
]
